import { render, staticRenderFns } from "./SpeakerSelector.vue?vue&type=template&id=84f3aaf6&scoped=true&"
import script from "./SpeakerSelector.vue?vue&type=script&lang=ts&"
export * from "./SpeakerSelector.vue?vue&type=script&lang=ts&"
import style0 from "./SpeakerSelector.vue?vue&type=style&index=0&id=84f3aaf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f3aaf6",
  null
  
)

export default component.exports